/**
 * @created : 2021/3/26
 * @author  : 王冲
 * @desc    : 主框架api请求
 */

import { request } from "@weapp/utils";
import { inPCClient } from "../utils";
import { ClientType } from "../components/main/navigation/widgets/quickToolbar/types";
import { SsoChangeParams, SsoCheckParams } from "../components/main/types";
//ETEAMSID 有效期14小时, 过期请更换
// import {TEAMS,ETEAMSID} from '../constants';

const baseweb = window.TEAMS?.service?.baseweb;

//更多应用--全部应用菜单
export const getApplications = (params?: any) => {
  params = { ...(params || {}), displayClient: inPCClient() ? "pc-weapp" : "pc" }
  return request({
    url: `/api/baseserver/queryApplicationList?displayModule=true`,
    method: "get",
    params
  });
};

//更多应用--常用菜单
export const getApplicationsFrequentlyUsed = () => {
  return request({
    url: `/api/baseserver/often/qryOftenApp?number=8`,
    method: "get"
  });
};

//常用菜单收集
export const updateApplicationFrequentlyUse = (moduleId: string) => {
  return request({
    url: `/api/bs/basicserver/often/gatherInfo?moduleId=` + moduleId,
    method: "get"
  });
};

//校验是否新增菜单
export const checkInitModule = () => {
  return request({
    url: `/api/basicserver/menu/checkInitModule`,
    method: "get",
  });
};

export const saveConfiguration = (data: any) => {
  return request({
    url: `/api/bcw/base/configuration/saveConfig`,
    method: "post",
    data: {
      'config': data
    }
  });
};

export const getUnfinishCount = () => {
  return request({
    url: `/api/app/project/entity/getUnfinishCount`,
    method: "get",
  });
};

export const queryWatchEntity = () => {
  // const formData = new FormData();
  // formData.append("module","production");
  // formData.append("loadCount","true");
  // formData.append("","");

  return request({
    url: `/api/app/my/watch/queryWatchEntity`,
    method: "post",
    // data:formData
    data: {
      "module": "task",
      "pageSize": 15,
      "pageNo": 1,
      "filter": {
        "keywords": ""
      },
      'loadCount': true
    }
  });
};
export const queryWaitCount = () => {
  return request({
    url: `/api/app/my/workWait/getIMSubscriptCount?type=2`,
    method: "get",
  });
};
//H5更多应用--全部应用菜单
export const getMobileApplications = (params?: any) => {
  if (!params) {
    params = {} as any;
  }
  params.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/app/baseserver/queryApplicationList?noFilterModules=true`,
    method: "get",
    params
  });
};

//顶部导航应用
export const getCustomAPPmenus = (params?: any) => {
  if (!params) {
    params = {} as any;
  }
  params.displayClient = inPCClient() ? "pc-weapp" : "pc";
  return request({
    url: `/api/baseserver/queryEmpMenusContext`,
    method: "get",
    params,
  });
};

//顶部导航应用
export const getHrAvatar = () => {
  return request({
    url: `/api/hrm/profile/get?id=${window.TEAMS?.currentUser?.id}`,
    method: "get",
  });
};

//团队列表
export const getsiblingstenant = () => {
  return request({
    url: `/api/app/basicserver/siblingstenant/list`,
    method: "get",
  });
};

//团队列表切换时更改权限
export const changeTenantPermission = (params: any) => {
  const formData = new FormData();
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      formData.append(key, params[key]);
    }
  }
  return request({
    url: `/api/basicserver/ipconfigrec/checkChangeTenantPermission`,
    method: "GET",
    params: {
      ...params
    }
  });
};
//团队列表切换更改LoginType
export const checkChangeTenantLoginType = (params: any) => {
  return request({
    url: `/api/basicserver/loginType/checkChangeTenantLoginType`,
    method: "get",
    params: {
      ...params
    }
  });
};

//快捷新建菜单
export const getEmpMenuEntrances = () => {
  return request({
    url: `/api/basicserver/menuentrance/queryEmpMenuEntrances`,
    method: "get",
    params: { menuType: '0' }
  });
};

//快捷新建菜单-移动端
export const getMobileEmpMenuEntrances = () => {
  return request({
    url: `/api/app/basicserver/menuentrance/queryEmpMenuEntrances`,
    method: "get",
    params: { menuType: '0' }
  });
};

//左侧菜单配置--暂无接口
export const getAsideMenuData = () => {
  return request({
    url: `${baseweb}/customappmenus/queryAsideMenuData`,
    method: "get",
  });
};

// help-意见反馈保存
export const saveFeedBackMsg = (value: any) => {
  let formData = new FormData();
  formData.append('content', value);
  formData.append("eteamsId", window.ETEAMSID)
  formData.append("employeeId", window.TEAMS?.currentUser?.employeeId)
  formData.append("tenantKey", window.TEAMS?.currentTenant?.tenantKey)
  return request({
    url: `/papi/tenantoperation/adviseinfo/advise`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData
  });
};

// 当前人员是否有邀请权限
export const checkInviteForbid = () => {
  let formData = new FormData();
  formData.append('userId', window.TEAMS?.currentUser?.id);
  formData.append('configName', 'inviteForbid');
  return request({
    url: `/api/bcw/base/configuration/existConfigRange`,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: formData
  });
};

//当前人员是否有可视化菜单开启权限
export const checkoutMenuVisibilityVisible = () => {
  return request({
    url: `/api/basicserver/menu/check-permission`,
    method: "post",
    data: { "menuCode": "ecode" }
  });
}

export const checkPortalConfig = () => {
  let formData = new FormData();
  formData.append('belong', 'mobile');
  return request({
    url: `/api/portal/mainpage/getFixedMenuId`,
    method: "post",
    data: formData
  });
};

// 获取应用管理--应用展示默认设置
export const queryEmpAppManageConfigs = () => {
  return request({
    url: `/api/basicserver/app/manage/queryEmpAppManageConfigs`,
    method: "get",
  });
}

//获取导航菜单配置
export const getNavMenuList = () => {
  return request({
    url: `/api/basicserver/navimenu/${inPCClient() ? 'pc/' : ''}queryNaviMenuListGroupBy?filterAuth=true`,
    method: "GET",
    params: {
      client: inPCClient() ?
        ClientType.CLIENT :
        ClientType.WEBCLIENT
    }
  });
};

//通过configKey查询应用显示设置-团队
export const queryAppConfigByKey = (params: any) => {
  return request({
    url: `/api/basicserver/app/manage/getAppManageConfig`,
    method: "get",
    params
  });
};


//通过configKey查询应用显示设置-个人
export const queryEmpConfigByKey = (params: any) => {
  return request({
    url: `/api/basicserver/app/manage/getEmpAppManageConfig`,
    method: "get",
    params
  });
};


//快捷搜索是是否开启
export const queryQuickNeedShow = () => {
  return request({
    url: `/api/basicserver/quicksearch/queryQuickNeedShow`,
    method: "GET",
  });
};

//快捷搜索对象列表
export const getQuickSearchList = () => {
  return request({
    url: `/api/basicserver/quicksearch/queryListForWeb`,
    method: "GET",
  });
};

//快捷搜索历史
export const getQuickSearchHistory = () => {
  return request({
    url: `/api/basicserver/search/queryHistories?conditionId=quickSearch`,
    method: "GET",
  });
};

//记录搜索历史
export const addQuickSearchHistory = (keyword: string) => {
  return request({
    url: `/api/basicserver/search/addToHistory`,
    method: "POST",
    data: {
      conditionId: "quickSearch",
      content: keyword,
      itemId: "",
      sequence: 1,
      sort: 0
    }
  });
}

//删除搜索历史
export const deleteSearchHistory = (id: string) => {
  return request({
    url: `/api/basicserver/search/deleteHistory`,
    method: "POST",
    params: { id }
  });
}

//清空搜索历史
export const clearSearchHistory = () => {
  return request({
    url: `/api/basicserver/search/clearHistory`,
    method: "POST",
    params: {
      conditionId: "quickSearch",
    }
  });
}

//热点搜查查询
export const queryHotSearch = (key: string) => {
  return request({
    url: `/api/esearch/search/recentquery/querySuggest`,
    method: "GET",
    params: {
      prefix: key,
      limit: 10,
      tenantKey: window.TEAMS?.currentTenant?.tenantKey,
      // currentUser: window.TEAMS?.currentUser?.id,
      currentUser: "ALL",
    }
  });
}

export const saveUserConfig = (data: any) => {

  return request({
    url: `/api/bcw/base/configuration/saveConfig`,
    method: "post",
    data: data
  });
};
export const updateUserConfig = (data: any) => {

  return request({
    url: `/api/bcw/base/configuration/updateConfigValue`,
    method: "post",
    data: data
  });
};

//导航菜单邮箱是否显示查询
export const mailVisible = (code: string) => {
  return request({
    url: `/api/bs/intmail/navigation/check_mail_visible?product_type_code=${code}`,
    method: "get",
  });
}
export const mailVisibleBatch = () => {
  return request({
    url: `/api/bs/intmail/navigation/get_mail_visible`,
    method: "get",
  });
}
//导航菜单邮箱是否显示查询
export const getCurrentUserName = () => {
  return request({
    url: `/api/hrm/card/getCurrentSimpleEmployee`,
    method: "get",
  });
}

//在线人员状态
export const basicOnlineExitConn = (data: any) => {
  return request({
    url: `/papi/basiconline/offline/exitConn`,
    method: "post",
    data: data
  });
}

//获取pc/H5切换团队单点信息
export const ssoCheck = (data: SsoCheckParams) => {
  return request({
    url: `/papi/passport/checkTenant/ssoCheck`,
    method: "post",
    data: data
  });
}

//跨环境单点
export const ssoChange = (domain: any, data: SsoChangeParams) => {
  return request({
    url: `${domain}/papi/passport/changeTenant/ssoChange?service=${encodeURIComponent(data.service)}&changeInfo=${encodeURIComponent(data.changeInfo)}`,
    method: "get",
  });
}
//清除缓存
export const clearCookie = () => {
  return request({
    url: `/papi/app/baseserver/clearCookie`,
    method: "GET",
  });
};
//登出日志记录
export const loginLogRecord = () => {
  return request({
    url: `/api/basicserver/logs/addLoginOutLog`,
    method: "GET",
  });
};
//我的好友菜单
export const getFriend = () => {
  return request({
    url: `/api/app/bs/hrm/friend/conf/support`,
    method: "GET",
  });
};
//我的好友菜单和关注人员未读数
export const getPeopleMenuCount = () => {
  return request({
    url: `/api/app/bs/hrm/me/h5undo/count`,
    method: "GET",
  });
};
//我的好友菜单未读数
export const getFriendCount = () => {
  return request({
    url: `/api/app/bs/hrm/friend/unhandledReqCount`,
    method: "GET",
  });
};
//跨环境单点重定向
// export const ssoRedirect = (data: any) => {
//   return request({
//     url: `/papi/baseserver/sso/domainRedirect?service=${encodeURIComponent(data.service)}&eteamsid=${data.eteamsid}`,
//     method: "get",
//   });
// }

export const generateNewTicket = (url: string = window.location.href) => {
  return request({
    url: `/api/baseserver/login/generateNewTicket`,
    method: "post",
    headers: {
      "Content-Type": "application/form-data",
    },
    params: {
      targetUrl: url
    }
  });
}

//前台-列表展示
export const queryFrontSingleNavigationMenuList = () => {
  return request({
    url: '/api/basicserver/singlenavimenu/queryFrontSingleNavigationMenuList',
    method: 'get',
    params: {
      clientType: 'appClient'
    }
  })
}

//获取企业Logo图标
export const getTenantLogo = () => {
  return request({
    // url: "/api/baseserver/layout/getTenantLogo",
    url: "/api/baseserver/getTenantLogo",
    method: 'get',
  })
}